import { actions } from '../store';
import { Extension } from '../model/uc';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { useSelector } from '../hook-utils';
import { getExtensionsByIds } from '../api';
import { RenderSelection } from './ExtensionsPage';
import { useEffect, useMemo, useState } from 'react';
import { selectMyAccess, selectMyself } from '../store/reducers/config';

const AchieveExtension = () => { 
  const myId = useSelector(selectMyself)
  const access = useSelector(selectMyAccess)
  const dispatch = useDispatch()
  const { extension } = useParams() as { extension: string }
  const [extensionCode, setExtensionCode] = useState<Extension | null | undefined>(undefined)
  const edit = useMemo(() => (myId && ((myId.id === extension && access.features.configMyExtension) || access.features.configAllExtensions)) || false, [myId, extension, access])

  useEffect(() => {
    async function fetch() {
      if (!myId) return      
      const extensions = await getExtensionsByIds(myId, [{ id: extension, server: myId.server }], 0)        
      if (extensions && extensions.rows.length > 0) {
        dispatch(actions.fetchExtensionsByIdsResponse(extensions.rows))    
        setExtensionCode(extensions.rows[0])
      }
      else {
        setExtensionCode(undefined)
      }
    }
    dispatch(actions.showMainToolbar(false))
    fetch()
  }, [dispatch, extension, myId])

  return (
    (myId && extensionCode)  ? <RenderSelection id={extensionCode} edit={edit} myId={myId} /> : <h1>Extension not found</h1>
  )
}

export default AchieveExtension



